'use client'

import { useTranslations } from 'next-intl'
import { useCountdown } from '@/app/hooks/useCountdown'

interface ChannelFooterFooterProps {
  isFetching: boolean
}

export const ChannelFooter = ({ isFetching }: ChannelFooterFooterProps) => {
  const t = useTranslations()

  const { seconds } = useCountdown({
    initialSeconds: 15,
    forceReset: isFetching,
  })
  return (
    <div className="pt-3 text-center">
      <p className="text-sm font-medium text-status-warning-500">
        {t('ratesWillRefreshAfter', {
          amount: seconds,
        })}
      </p>
    </div>
  )
}
